import React, { useState, useEffect, Link } from "react";
import axios from 'axios';
import { alert_error, alert_success } from "../../AppContext.js";
import StatusBadge from "../../js/buttonstatus.jsx";

const MyTableComponent = () => {
    const [id_orders, set_id_orders] = useState('');
    const [username, set_username] = useState('');
    const [chedo, set_chedo] = useState('');
    const [value, set_value] = useState('');
    const [note, set_note] = useState('');
    const [money, set_money] = useState('');
    const [coin_digital, set_coin_digital] = useState('');
    const [status_search, set_status_search] = useState('');
    const [coin_pay_out, set_coin_pay_out] = useState('');
    const [isQrModalVisible, setQrModalVisible] = useState(false);
    const [qrRow, setQrRow] = useState(null);

    const [data, set_data] = useState([
        {
            stt: 1,
            name: "Service 1",
            money: "1000",
            id: "123",
            minorder: "10",
            category: "Category 1",
            status: "Active",
        },
        {
            stt: 2,
            name: "Service 2",
            money: "2000",
            id: "124",
            minorder: "20",
            category: "Category 2",
            status: "Inactive",
        },
    ]);

    const fetchData = () => {
        axios.get('https://hust.media/hustadmin_v2/deposit_list.php', {
            params: {
                id_orders: id_orders,
                username: username,
                status: status_search
            }
        })
            .then((response) => {
                testFunction(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    };

    function testFunction(response) {
        set_data(response.data);
    }

    useEffect(() => {
        fetchData();
    }, []);

    const handleInputChange1 = (event) => set_username(event.target.value);
    const handleInputChange2 = (event) => set_id_orders(event.target.value);
    const change_value = (event) => set_value(event.target.value);
    const change_note = (event) => set_note(event.target.value);
    const change_money = (event) => set_money(event.target.value);
    const change_coin_digital = (event) => set_coin_digital(event.target.value);
    const change_status_search = (event) => set_status_search(event.target.value);
    const change_coin_pay_out = (event) => set_coin_pay_out(event.target.value);

    const member_edit = (event) => {
        event.preventDefault();
        axios.get('https://hust.media/hustadmin_v2/deposit_edit.php', {
            params: {
                id_orders: value,
                chedo: chedo,
                note: note,
                money: money,
                coin_digital: coin_digital,
                coin_pay_out: coin_pay_out
            }
        })
            .then((response) => {
                testFunction2(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    };

    function testFunction2(response) {
        alert_success(response.data);
        fetchData();
        closeModal();
    }

    const [isModalVisible, setModalVisible] = useState(false);
    const closeModal = () => setModalVisible(false);
    const openModal = (row) => {
        set_users_edit(row);
        setModalVisible(true);
    };
    const [users_edit, set_users_edit] = useState('');

    const options = [
        { id: 1, name: 'Processing', value: 'Processing' },
        { id: 2, name: 'In progress', value: 'In progress' },
        { id: 3, name: 'Completed', value: 'Completed' },
        { id: 4, name: 'Canceled', value: 'Canceled' }
    ];

    useEffect(() => {
        if (users_edit.id) {
            set_value(users_edit.id);
        }
    }, [users_edit]);

    const change_chedo = (event) => {
        const selectedValue = event.target.value;
        set_chedo(selectedValue);
        console.log(`Selected option: ${selectedValue}`);
    };

    const getBankQrUrl = (row) => {
        const bankCode = (row.api_url || '').trim();
        const accountNo = (row.api_key || '').trim();
        if (!bankCode || !accountNo) {
            return '';
        }
        const amount = (row.money || '').toString().trim();
        const baseUrl = `https://img.vietqr.io/image/${encodeURIComponent(bankCode)}-${encodeURIComponent(accountNo)}-compact2.png`;
        return amount ? `${baseUrl}?amount=${encodeURIComponent(amount)}` : baseUrl;
    };

    const openQrModal = (row) => {
        const qrUrl = getBankQrUrl(row);
        if (!qrUrl) {
            return;
        }
        setQrRow(row);
        setQrModalVisible(true);
    };

    const closeQrModal = () => {
        setQrModalVisible(false);
        setQrRow(null);
    };

    const markQrCompleted = () => {
        if (!qrRow || !qrRow.id) {
            return;
        }
        axios.get('https://hust.media/hustadmin_v2/deposit_edit.php', {
            params: {
                id_orders: qrRow.id,
                chedo: 'Completed',
                note: 'đã chuyển',
                money: '',
                coin_digital: '',
                coin_pay_out: ''
            }
        })
            .then((response) => {
                alert_success(response.data);
                fetchData();
                closeQrModal();
            })
            .catch((error) => {
                alert_error(error);
            });
    };

    return (
        <div className="card-body mx-2 my-2">
            <div className="flex gap-2 items-center">
                {!isModalVisible ? (<></>) : (
                    <div className="App">
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                                <h2 className="text-lg font-semibold mb-2">Chỉnh sửa</h2>
                                <form onSubmit={member_edit}>
                                    <div className="mb-4">
                                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
                                            id_orders {users_edit.id}
                                            <div>Username {users_edit.username}</div>
                                        </label>

                                        <select
                                            id="select"
                                            value={chedo}
                                            onChange={change_chedo}
                                            className="mb-2 block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                        >
                                            <option value="" disabled>Select an option</option>
                                            {options.map((option) => (
                                                <option key={option.id} value={option.name}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>

                                        <input
                                            onChange={change_value}
                                            value={value}
                                            type="text"
                                            id="value"
                                            placeholder="value"
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        />
                                        <input
                                            onChange={change_note}
                                            value={note}
                                            type="text"
                                            id="note"
                                            placeholder="note: kết quả"
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        />
                                        <input
                                            onChange={change_money}
                                            value={money}
                                            type="money"
                                            id="money"
                                            placeholder="money orders"
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        />
                                        <input
                                            onChange={change_coin_digital}
                                            value={coin_digital}
                                            type="coin_digital"
                                            id="coin_digital"
                                            placeholder="coin_digital"
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        />
                                        <input
                                            onChange={change_coin_pay_out}
                                            value={coin_pay_out}
                                            type="coin_pay_out"
                                            id="coin_pay_out"
                                            placeholder="coin_pay_out"
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        />
                                    </div>

                                    <div className="flex items-center justify-between">
                                        <button
                                            type="submit"
                                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                        >
                                            Submit
                                        </button>
                                        <button
                                            onClick={closeModal}
                                            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}
                {!isQrModalVisible ? (<></>) : (
                    <div className="App">
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                                <h2 className="text-lg font-semibold mb-2">QR ngân hàng</h2>
                                <div className="mb-4 flex justify-center">
                                    <img
                                        src={qrRow ? getBankQrUrl(qrRow) : ''}
                                        alt="bank qr"
                                        className="w-68 h-68 object-contain"
                                    />
                                </div>
                                <div className="flex items-center justify-between">
                                    <button
                                        onClick={markQrCompleted}
                                        className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                    >
                                        Đã chuyển
                                    </button>
                                    <button
                                        onClick={closeQrModal}
                                        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="flex flex-wrap gap-2 items-center mb-4">
                    {/* Ô username */}
                    <div className="flex items-center gap-2">
                        <input
                            type="text"
                            placeholder="username"
                            value={username}
                            onChange={handleInputChange1}
                            onKeyPress={fetchData}
                            className="border border-gray-400 rounded px-3 py-2 text-sm w-48"
                        />
                        <button
                            onClick={() => fetchData()}
                            className="bg-blue-500 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
                        >
                            search
                        </button>
                    </div>

                    {/* Ô id_orders */}
                    <div className="flex items-center gap-2">
                        <input
                            type="text"
                            placeholder="id_orders"
                            value={id_orders}
                            onChange={handleInputChange2}
                            onKeyPress={fetchData}
                            className="border border-gray-400 rounded px-3 py-2 text-sm w-48"
                        />
                        <button
                            onClick={() => fetchData()}
                            className="bg-blue-500 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
                        >
                            search
                        </button>
                    </div>

                    {/* ✅ Select status có kích thước khớp */}
                    <div className="flex items-center gap-2 w-full mt-2">
                        <select
                            value={status_search}
                            onChange={change_status_search}
                            className="border border-gray-400 rounded px-3 py-2 text-sm w-48 bg-white"
                        >
                            <option value="">Tất cả trạng thái</option>
                            {options.map((option) => (
                                <option key={option.id} value={option.value}>
                                    {option.name}
                                </option>
                            ))}
                        </select>
                        <button
                            onClick={() => fetchData()}
                            className="bg-blue-500 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
                        >
                            search
                        </button>
                    </div>
                </div>
            </div>

            <div className="table-responsive-sm">
                <table className="table-auto w-full border-collapse">
                    <thead>
                        <tr>
                            <th className="border text-center py-2" style={{ width: "8%" }}>id_donate</th>
                            <th className="border text-center py-2" style={{ width: "12%" }}>Username</th>
                            <th className="border text-center py-2" style={{ width: "10%" }}>service_name</th>
                            <th className="border text-center py-2" style={{ width: "10%" }}>Tiền rút</th>
                            <th className="border text-center py-2 w-1/12">Trạng thái</th>
                            <th className="border text-center py-2 w-1/12">api_url</th>
                            <th className="border text-center py-2 w-1/12">api_key</th>
                            <th className="border text-center py-2 w-2/12">Lý do rút tiền</th>
                            <th className="border text-center py-2 w-1/12">note</th>
                            <th className="border text-center py-2 w-1/12">createdate</th>
                            <th className="border text-center py-2 w-1/14">QR</th>
                            <th className="border text-center py-2 w-1/12">THAO TÁC</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => (
                            <tr key={index}>
                                <td className="border text-center py-2 break-all">{row.id}</td>
                                <td className="border text-center py-2 break-all"><b>{row.username}</b></td>
                                <td className="border text-center py-2 break-all">{row.service_name}</td>
                                <td className="border text-center py-2 break-all">{row.money}</td>
                                <td className="border text-center py-2 break-all"><StatusBadge status={row.status} /></td>
                                <td className="border text-center py-2 break-all">{row.api_url}</td>
                                <td className="border text-center py-2 break-all">{row.api_key}</td>
                                <td className="border text-center py-2 break-all">{row.comments}</td>
                                <td className="border text-center py-2 break-all">{row.note}</td>
                                <td className="border text-center py-2 break-all">{row.createdate}</td>
                                <td className="border text-center py-2">
                                    <div onClick={() => openQrModal(row)} className="btn btn-default">
                                        QR
                                    </div>
                                </td>
                                <td className="border text-center py-2">
                                    <div onClick={() => openModal(row)} href={`edit-dich-vu.php?id=${row.id}`} className="btn btn-default">
                                        <i className="fas fa-edit"></i> Edit
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MyTableComponent;
